namespace Vit.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<UserTenantRoleDefinition> {
    }
}